import React from "react";
import moment from "moment";
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { RESOURCE } from "../../../const/resource";
import { useTranslation } from "react-i18next";
import { ICartExport } from "../CartExcelExport/cartexcelexportinterface";
import helperfunctions from "../../../utils/helperfunctions";
import { AVAILABILITYTYPE, CARTDOWNLOADFIELD } from "../../../const/enum";

const CartExcelExport = (props: ICartExport) => {
    const { cartData, cartExcelRef } = props;
    const { t } = useTranslation();
    const clonedArray = cartData?.map((obj: any) => ({ ...obj }));
    const filteredData = clonedArray?.map((item: any) => {

        item[CARTDOWNLOADFIELD[CARTDOWNLOADFIELD.dealerAvailability]] = item?.availability?.find((t: any) => t.type?.toLowerCase() == AVAILABILITYTYPE[AVAILABILITYTYPE.da])?.availabilityCountStr;
        item[CARTDOWNLOADFIELD[CARTDOWNLOADFIELD.komastuAvailability]] = item?.availability?.find((t: any) => t.type?.toLowerCase() == AVAILABILITYTYPE[AVAILABILITYTYPE.ka])?.availabilityCountStr;
        item[CARTDOWNLOADFIELD[CARTDOWNLOADFIELD.branchAvailability]] = item?.availability?.find((t: any) => t.type?.toLowerCase() != AVAILABILITYTYPE[AVAILABILITYTYPE.da] && t.type?.toLowerCase() != AVAILABILITYTYPE[AVAILABILITYTYPE.ka])?.availabilityCountStr;;
        item[CARTDOWNLOADFIELD[CARTDOWNLOADFIELD.manufacturer]] = item?.manufacturer?.name;
        item[CARTDOWNLOADFIELD[CARTDOWNLOADFIELD.machine]] = `${item?.machine?.modelDisplay ? item?.machine?.modelDisplay : ""}`;
        item[CARTDOWNLOADFIELD[CARTDOWNLOADFIELD.itemTotal]] = `$${helperfunctions.formatAmount(item?.itemTotal)}`;
        let unitPrice = '';
        if (item?.substituteParts?.length > 0) {
            const itemTotal = item?.substituteParts.reduce((a:any, b:any) => {
                return a + b['itemTotal'];
            }, 0);
            item[CARTDOWNLOADFIELD[CARTDOWNLOADFIELD.itemTotal]] = `$${helperfunctions.formatAmount(itemTotal)}`;
            const hasInvalidProduct = item?.substituteParts.some((item: any) => item.isValidKomatsuProduct === false);
            if (hasInvalidProduct) {
                unitPrice = t(RESOURCE.MyK_Label_SC_Contact_Dealer);
            } else {
                unitPrice = t(RESOURCE.MyK_Label_SC_Substituted);
            }
        } else if (item?.isValidKomatsuProduct === false) {
            unitPrice = t(RESOURCE.MyK_Label_SC_Contact_Dealer);
        } else {
            unitPrice = `$${helperfunctions.formatAmount(item?.unitPrice)}`;
        }
        
        item[CARTDOWNLOADFIELD[CARTDOWNLOADFIELD.unitPrice]] = unitPrice;
        if (item[CARTDOWNLOADFIELD[CARTDOWNLOADFIELD.branchAvailability]] == undefined || item[CARTDOWNLOADFIELD[CARTDOWNLOADFIELD.branchAvailability]] == null || item[CARTDOWNLOADFIELD[CARTDOWNLOADFIELD.branchAvailability]]?.trim() == '') {
            item[CARTDOWNLOADFIELD[CARTDOWNLOADFIELD.branchAvailability]] = item.availability[0].isContactDealer ? t(RESOURCE.MyK_Label_SC_Contact_Dealer) : '';
        }
        return item;
    });

    return (
        <ExcelExport
            fileName={"ShoppingCart_" + moment().format("YYYYMMDDhhmmss") + ".xlsx"}
            data={filteredData}
            ref={cartExcelRef}
        >
            <ExcelExportColumn
                key={0}
                title={t(RESOURCE.MyK_Grid_Part_Number)}
                field="partNumber"
            />
            <ExcelExportColumn
                key={1}
                title={t(RESOURCE.MyK_Label_ManufacturerName)}
                field="manufacturer"
            />
            <ExcelExportColumn
                key={2}
                title={t(RESOURCE.MyK_Grid_Quantity)}
                field="quantity"
            />
            <ExcelExportColumn
                key={3}
                title={t(RESOURCE.MyK_Grid_Description)}
                field="description"
            />
            <ExcelExportColumn
                key={4}
                title={t(RESOURCE.MyK_Label_ShoppingCart_Branch_Availability)}
                field="branchAvailability"
            />
            <ExcelExportColumn
                key={5}
                title={t(RESOURCE.MyK_Label_ShoppingCart_Dealer_Availability)}
                field="dealerAvailability"
            />
            <ExcelExportColumn
                key={6}
                title={t(RESOURCE.MyK_Label_ShoppingCart_Komatsu_Availability)}
                field="komastuAvailability"
            />
            <ExcelExportColumn
                key={7}
                title={t(RESOURCE.MyK_Label_ShoppingCart_Unit_Price)}
                field="unitPrice"
            />
            <ExcelExportColumn
                key={8}
                title={t(RESOURCE.MyK_Label_ShoppingCart_Item_Total)}
                field="itemTotal"
                cellOptions={{
                    textAlign: 'right'
                }}
            />           
            <ExcelExportColumn
                key={9}
                title={t(RESOURCE.MyK_Grid_Machine)}
                field="machine"
            />

        </ExcelExport>
    );
};

export default CartExcelExport;
